export default __webpack_public_path__ + "static/media/WelcomeView_2A-min.b35a8e9d.png";